
import * as getters from './getters'
import mutations from './mutations'
import * as actions from './actions'
const stroage = {
  menus: [],
  userInfo: { roles: [] }
}

if (YJ_SCHOOL_STORAGE.getItem('userInfo')) {
  stroage.userInfo = JSON.parse(YJ_SCHOOL_STORAGE.getItem('userInfo'))
  stroage.menus = JSON.parse(YJ_SCHOOL_STORAGE.getItem('menus'))
}
const state = {
  loading: false,
  currentPage: 1,
  headerStatus: true,
  entraMenus: []
}

export default {
  state,
  getters,
  mutations,
  actions
}
